import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { tomoIncludes, tomos } from '../../data/landing';
export function Tomos() {
  return <section className="bg-brand-soft px-5 py-16 md:py-24" data-id="element-270" data-mp="7wjeqqunaimx">
      <div className="mx-auto max-w-6xl" data-id="element-271" data-mp="7z5vnh3feaht">
        <div className="mx-auto max-w-3xl text-center" data-id="element-272" data-mp="cwpcmorid1dg">
          <TrophyIcon className="mx-auto h-10 w-10 text-gold-strong" aria-hidden="true" data-id="element-273" data-mp="cy8o8227yo8w" />
          <h2 className="mt-4 text-3xl font-black uppercase leading-[1.1] tracking-tight text-brand md:text-5xl" data-id="element-274" data-mp="3bfmioscdrgnb">
            MegaPack Colon Tranquilo <Highlight data-id="element-275" data-mp="3lc91zcp25zn8">en 7 Días™</Highlight>
          </h2>
          <p className="mt-5 text-xl font-bold text-charcoal" data-id="element-276" data-mp="3lao71lyu0eou">5 Tomos + 5 Bonos — Días 1 → 7</p>
          <p className="mt-1 text-lg text-muted" data-id="element-277" data-mp="3qcdih2pyuudg">420+ páginas — Todo resuelto.</p>
        </div>

        <h3 className="mt-14 text-center text-sm font-bold uppercase tracking-[0.2em] text-brand" style={{
        fontSize: "16px"
      }} data-id="element-278" data-mp="10lgw8rr18bem">
          5 Tomos completos
        </h3>

        <ol className="mt-8 space-y-4" data-id="element-279" data-mp="1hrpjsj0nd60t">
          {tomos.map(t => <li key={t.number} className="grid grid-cols-[auto_1fr] items-center gap-5 rounded-3xl bg-white p-5 shadow-sm md:grid-cols-[auto_240px_1fr] md:gap-8 md:p-6" data-id="element-280" data-mp="1ctxi4xa7a5jf">
              <span className="flex h-16 w-14 flex-col items-center justify-center rounded-lg text-white shadow-md md:h-20 md:w-16" style={{
            backgroundColor: t.color
          }} aria-hidden="true" data-id="element-281" data-mp="13tsixaf5udgc">
                <span className="text-[10px] font-bold uppercase tracking-wider opacity-90" data-id="element-282" data-mp="u13bqrqn7lqt">Tomo</span>
                <span className="text-2xl font-black leading-none md:text-3xl" data-id="element-283" data-mp="p20c5mtfm7q8">{t.number}</span>
              </span>
              <div data-id="element-284" data-mp="g3eyo62thiwb">
                <p className="text-sm font-bold uppercase tracking-wider" style={{
              color: t.color
            }} data-id="element-285" data-mp="g3yar65sdd2f">
                  {t.days}
                </p>
                <p className="text-lg font-extrabold leading-tight text-brand md:text-xl" data-id="element-286" data-mp="b53o1t4p74d1">
                  {t.title}
                </p>
              </div>
              <p className="col-span-2 text-base text-charcoal md:col-span-1" data-id="element-287" data-mp="6g2n6sb6aiu3">{t.description}</p>
            </li>)}
        </ol>

        <div className="mt-10 rounded-3xl bg-brand p-7 md:p-10" data-id="element-288" data-mp="3npqz3ngtq6dl">
          <p className="text-xl font-extrabold text-white" data-id="element-289" data-mp="3so2a41iuumxe">Cada tomo incluye:</p>
          <ul className="mt-5 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-290" data-mp="k6nztza19wjj">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3 text-base text-white" data-id="element-291" data-mp="p6k66567e029">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-292" data-mp="ahxq218r549z">
                  <CheckIcon className="h-3.5 w-3.5 text-brand" strokeWidth={3.5} aria-hidden="true" data-id="element-293" data-mp="fffouyt22349" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}